<template>
  <v-icon>{{name}}</v-icon>
</template>

<script>
export default {
  name: "FavoriteIcon",
  props: {
    on: {
      type: Boolean
    }
  },
  computed: {
    name() {
      if(this.on) {
        return 'mdi-heart'
      } else {
        return 'mdi-heart-outline'
      }
    }
  }
}
</script>

<style scoped>

</style>